export var oConstants = {
    result:{}
};